import {
    NavController,
    NavParams,
    App,
    ModalController,
    ViewController,
    ToastController,
  } from "ionic-angular";
  import { Storage } from "@ionic/storage";
  import { Component, OnInit, Input } from "@angular/core";
  
  import { AuthProvider } from "../../../../providers/auth/auth";
  import { EmployeeRhProvider } from "../../../../providers/employeerh/employeerh";
  import { GoalRhProvider } from "../../../../providers/goals/goals";
import { TodoRhProvider } from "../../../../providers/tasks/tasks";
  
  @Component({
    selector: "page-rh-tasks",
    templateUrl: "rh-tasks.html",
  })
  export class RhTasksPage implements OnInit {

    ownTasks:any = null;
    otherTasks:any = null;

    constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public storageProvider: Storage,
      public app: App,
      public authProvider: AuthProvider,
      public employeeRhProvider: EmployeeRhProvider,
      public viewCtrl: ViewController,
      public toastCtrl: ToastController,
      public modalCtrl: ModalController,
      private todoRhProvider: TodoRhProvider
    ) {

    }
  
    ngOnInit() {
      this.loadDatas();
    }
  
    loadDatas() {
      this.todoRhProvider.getMobileUserTasks().subscribe((res) => {
        if(res.success){
          this.ownTasks = res.data.userOwnProcessTasks
          this.otherTasks = res.data.userOtherProcessTasks
        }
      })
    }

    validateTask(task){
      this.todoRhProvider.updateProcessTaskState(task.id, 1).subscribe((res) => {
        if(res.success){
          let toast = this.toastCtrl.create({ message: "Tâche validée", duration: 4000, position: 'top'});
          toast.present()
          this.loadDatas();
        }
      })
    }

    // Modal ctrl
    dismiss() {
      this.viewCtrl.dismiss();
    }
  }
  


// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-tasks/rh-tasks.ts